import { Trash2 } from "lucide-react";
import { useState } from "react";

import { AccessibleIcon } from "@/components/accessible-icon";
import { Button } from "@/components/button";
import { ConfirmationModal } from "@/components/confirmation-modal/ConfirmationModal";

interface DeleteBrandButtonProps {
  readonly brandName: string;
  readonly isDeleting?: boolean;
  readonly onDelete: () => void;
}

export function DeleteBrandButton({
  brandName,
  isDeleting = false,
  onDelete,
}: DeleteBrandButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex justify-start">
      <Button
        className="text-brand-edit-action-fg hover:bg-transparent"
        color="gray"
        isDisabled={isDeleting}
        onPress={() => setIsOpen(true)}
        size="md"
        variant="tertiary"
      >
        <AccessibleIcon>
          <Trash2 size={16} />
        </AccessibleIcon>
        Delete brand
      </Button>

      <ConfirmationModal
        confirmButtonText="Delete"
        icon={<Trash2 className="text-fg-error-primary" size={20} />}
        isOpen={isOpen}
        onConfirm={onDelete}
        onOpenChange={setIsOpen}
        text={`Are you sure you want to delete "${brandName}"? This action cannot be undone.`}
        title="Delete brand"
      />
    </div>
  );
}
